import Swiper from 'swiper';
import { Autoplay, EffectFade, Pagination, Keyboard } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';

export const initHomeCarousel = () => {

  const swiper = new Swiper(".home-carousel", {
    modules: [Autoplay, EffectFade, Pagination, Keyboard],
    allowTouchMove: false,
    effect: "fade",
    keyboard: {
      enabled: true,
    },
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
  });
  
};